import { InjectionToken } from '@angular/core';

export interface PopoutData {
    divisionName: string;
}

export const POPOUT_MODAL_DATA = new InjectionToken<PopoutData>('POPOUT_MODAL_DATA');

export enum PopoutModalName {
    'firstSetupGuidDetail' = 'CUSTOMER_DETAIL',

}

export let POPOUT_MODALS = {
};

